import { authService } from './auth';

/**
 * Проксирует запрос к серверу другого сайта экосистемы через witelab backend.
 * Позволяет управлять AI Lab / Mockup Lab / Daily Lab из единой админки.
 */
export async function siteProxy(
  siteId: string,
  path: string,
  options: { method?: string; body?: unknown } = {},
): Promise<unknown> {
  try {
    const res = await authService.apiFetch('/api/admin/sites/' + siteId + '/proxy', {
      method: 'POST',
      body: JSON.stringify({
        method: options.method || 'GET',
        path,
        body: options.body,
      }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new SiteProxyError(
        (err as { error?: string }).error || `Ошибка ${res.status}`,
        res.status,
      );
    }

    return res.json();
  } catch (e) {
    if (e instanceof SiteProxyError) throw e;
    throw new SiteProxyError('Сайт недоступен', 0);
  }
}

export class SiteProxyError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = 'SiteProxyError';
    this.status = status;
  }
}
